import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';


const RoleProtectedRoute = ({ allowedRoles, children }) => {
  const { user } = useContext(AuthContext);

  // If not logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" />;
  }

  // If the user's role is not in the allowedRoles array, redirect to custom 403 page
  if (allowedRoles && !allowedRoles.includes(user.role?.name)) {
    return <Navigate to="/403" />;
  }

  return children;
};

export default RoleProtectedRoute;